import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { weeklyDigest } from "@/mocks/guagua";

export default function WeeklySection() {
  return (
    <section id="weekly" className="w-full scroll-mt-20 border-b border-background-200 bg-background-50">
      <div className="w-full px-4 py-14 md:px-8 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <SectionHeading
              eyebrow="本周汇总"
              title="网爆吃瓜一周盘点"
              description="把这一周发生的话题按天串成一条线，周末花十分钟就能补齐进度，不用再翻十几个平台。"
            />
            <div className="mt-6 rounded-lg border border-accent-200 bg-accent-50 p-5">
              <p className="inline-flex items-center gap-2 text-sm font-semibold text-accent-800">
                <i className="ri-calendar-check-line leading-none" aria-hidden="true"></i>
                本周共收录 5 个话题
              </p>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                盘点每周固定更新，热门事件类合集会在话题出现后第一时间补充，必看清单随时调整。
              </p>
              <Link
                to="/weekly"
                className="mt-4 inline-flex items-center gap-1.5 rounded-md bg-foreground-950 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                查看完整盘点
                <i className="ri-arrow-right-line leading-none" aria-hidden="true"></i>
              </Link>
            </div>
          </div>

          <ol className="relative lg:col-span-8">
            <span className="absolute left-[15px] top-2 h-[calc(100%-1rem)] w-px bg-background-300" aria-hidden="true"></span>
            {weeklyDigest.map((item, index) => (
              <li key={item.id} className="relative pb-6 pl-12 last:pb-0">
                <span
                  className={`absolute left-0 top-1 flex h-8 w-8 items-center justify-center rounded-full border-2 border-background-50 font-heading text-xs font-bold ${
                    index === 0 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                  }`}
                >
                  {item.date.split("-")[1]}
                </span>
                <div className="rounded-lg border border-background-200 bg-background-100/60 p-4 transition-colors hover:border-primary-300 md:p-5">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="rounded-full bg-primary-100 px-2.5 py-0.5 text-xs font-semibold text-primary-700">
                      {item.day}
                    </span>
                    <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-900">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-500">{item.date}</span>
                  </div>
                  <h3 className="mt-2 font-heading text-base font-bold text-foreground-950 md:text-lg">{item.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}